import React from 'react'

const Loading = () => {
    return (
        <div className="flex justify-center items-center mt-24 pb-24">
            <h2 className="text-2xl">Loading...</h2>
        </div>
    )
}

export default Loading
